import * as React from 'react'
import Button from 'components/Button'

export default props => {
  const { showFileUploadModal, input } = props

  const audio = input.value || {}

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        rect
        ghost
        style={{ marginRight: '5px' }}
        onClick={() =>
          showFileUploadModal({ uploadType: 'audioForPorta' }).then(({ value }) => {
            input.onChange({})
            input.onChange(value)
          })
        }
      >
        Upload
      </Button>

      {audio?.original && (
        <>
          <Button color="" size="sm" rect ghost onClick={() => input.onChange({})}>
            Clear
          </Button>

          <audio controls style={{ width: '100%', marginBottom: '20px', marginTop: '20px' }}>
            <source src={audio.original} />
          </audio>
        </>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Porta/PortaSayPlay/UploadAudioForPorta.jsx